import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from './AbstractMutableSet.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../exceptions.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from './AbstractMutableCollectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HashMapKeysDefault$iterator$1Class;
function HashMapKeysDefault$iterator$1() {
  if (HashMapKeysDefault$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.da_1 = $entryIterator;
      }
      q1() {
        return this.da_1.q1();
      }
      r1() {
        return this.da_1.r1().m3();
      }
      q6() {
        return this.da_1.q6();
      }
    }
    initMetadataForClass($);
    HashMapKeysDefault$iterator$1Class = $;
  }
  return HashMapKeysDefault$iterator$1Class;
}
var HashMapKeysDefaultClass;
function HashMapKeysDefault() {
  if (HashMapKeysDefaultClass === VOID) {
    class $ extends AbstractMutableSet() {
      constructor(backingMap) {
        return new.target.x7(backingMap);
      }
      static x7(backingMap) {
        var $this = this.c8();
        $this.w7_1 = backingMap;
        return $this;
      }
      ea(element) {
        throw UnsupportedOperationException().a1('Add is not supported on keys');
      }
      j2(element) {
        return this.ea(element);
      }
      y4() {
        return this.w7_1.y4();
      }
      j9(element) {
        return this.w7_1.t4(element);
      }
      t2(element) {
        if (!true)
          return false;
        return this.j9(element);
      }
      p1() {
        var entryIterator = this.w7_1.l3().p1();
        return new (HashMapKeysDefault$iterator$1())(entryIterator);
      }
      q2() {
        return this.w7_1.q2();
      }
      p6() {
        return this.w7_1.p6();
      }
    }
    initMetadataForClass($, 'HashMapKeysDefault');
    HashMapKeysDefaultClass = $;
  }
  return HashMapKeysDefaultClass;
}
var HashMapValuesDefault$iterator$1Class;
function HashMapValuesDefault$iterator$1() {
  if (HashMapValuesDefault$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.fa_1 = $entryIterator;
      }
      q1() {
        return this.fa_1.q1();
      }
      r1() {
        return this.fa_1.r1().n3();
      }
      q6() {
        return this.fa_1.q6();
      }
    }
    initMetadataForClass($);
    HashMapValuesDefault$iterator$1Class = $;
  }
  return HashMapValuesDefault$iterator$1Class;
}
var HashMapValuesDefaultClass;
function HashMapValuesDefault() {
  if (HashMapValuesDefaultClass === VOID) {
    class $ extends AbstractMutableCollection() {
      constructor(backingMap) {
        return new.target.a8(backingMap);
      }
      static a8(backingMap) {
        var $this = this.n6();
        $this.z7_1 = backingMap;
        return $this;
      }
      t9(element) {
        throw UnsupportedOperationException().a1('Add is not supported on values');
      }
      j2(element) {
        return this.t9(element);
      }
      s9(element) {
        return this.z7_1.u4(element);
      }
      t2(element) {
        if (!true)
          return false;
        return this.s9(element);
      }
      p1() {
        var entryIterator = this.z7_1.l3().p1();
        return new (HashMapValuesDefault$iterator$1())(entryIterator);
      }
      q2() {
        return this.z7_1.q2();
      }
      p6() {
        return this.z7_1.p6();
      }
    }
    initMetadataForClass($, 'HashMapValuesDefault');
    HashMapValuesDefaultClass = $;
  }
  return HashMapValuesDefaultClass;
}
//region block: exports
export {
  HashMapKeysDefault as HashMapKeysDefaultd8xopyn6vbgh,
  HashMapValuesDefault as HashMapValuesDefault3j1xghpfb6bpq,
};
//endregion

//# sourceMappingURL=HashMapEntryDefault.mjs.map
